import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import posthog from "posthog-js"

/* Captures a $pageview on every SPA route change. PostHog only
 * auto-captures the initial document load for single-page apps, so
 * client-side navigations need this. No-ops when PostHog isn't
 * initialized (capture is a safe call). */
export function PostHogPageTracker() {
  const location = useLocation()

  useEffect(() => {
    // Safe no-op if PostHog was never initialized (no key configured).
    posthog.capture("$pageview", {
      $current_url: window.location.href,
      path: location.pathname,
    })
  }, [location])

  return null
}
